import { authRef } from "api";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getUser, addUserToFirestore } from "modules/auth/user/firebase";

export default function useAuthListener() {
  const dispatch = useDispatch();

  useEffect(() => {
    return authRef.onAuthStateChanged(
      async authUser => {
        if (authUser) {
          //if user is signed in

          if (!authUser.isAnonymous) {
            dispatch({ type: "GET_USER" });
            dispatch({ type: "LOGIN", payload: authUser });
            let firestoreUser = await getUser(authUser.uid);
            if (firestoreUser && !firestoreUser.uid) {
              firestoreUser = await addUserToFirestore(authUser);
            }
            dispatch({ type: "FIRESTORE_USER", payload: firestoreUser });
          } else {
            console.log("start user create for anon", new Date().getTime());
            let firestoreUser = await addUserToFirestore(authUser);
            console.log("finish user create", new Date().getTime());
            dispatch({ type: "FIRESTORE_USER", payload: firestoreUser });
            dispatch({ type: "LOGIN_ANON", payload: authUser });
          }
        } else {
          console.log("anon sign in ", new Date().getTime());
          await authRef.signInAnonymously();
        }
      },
      error => console.log("error in auth red", error)
    );
  }, [dispatch]);
}
